<template>
  <div
      class="sm-products-scroll-handler sm-products-scroll-handler_full"
      :class="{'sm-hidden' : curMode === 'start'}"
      style="position:relative;"
  >
    <h1 v-if="selected_category_name" class="sm-title">
      {{ selected_category_name }}
    </h1>
    <div v-if="!isOpenFacets" class="sm-products">

      <NotFound v-if="isWasSearch && !totalHits"></NotFound>
      <div class="sm-title" v-if="!totalHits">Популярные товары</div>

      <ProductsGrid container_class="sm-products-grid_horde" />

      <infinite-loading
          force-use-infinite-wrapper=".sm-products-scroll-handler"
          @infinite="loadMore"
          :infinite-scroll-disabled="isLoading"
          ref="InfiniteLoading"
      >
        <div slot="no-more"></div>
        <div slot="no-results"></div>
      </infinite-loading>
    </div>
    <div v-else class="sm-facets">
    </div>

  </div>
</template>

<script>
import ProductsGrid from './grid/products-grid.vue';
import FacetCategories from './facets/facet-categories.vue';
import Facets from './facets/facets.vue';
import Sort from './grid/sort.vue';
import NotFound from './facets/not-found.vue';
import Tips from './grid/tips.vue';

import FacetSlider from './facets/facet-slider.vue';

import {mapGetters, mapActions} from "vuex";
import BackToTop from './grid/backtotop.vue'
import InfiniteLoading from 'vue-infinite-loading';

export default {
name: "sm-main-scroll-wrapper-mobile",
  computed: {
    ...mapGetters("search", [
        "mode",
        "search",
        "currentPage",
        "pageSize",
        "totalHits",
        "isWasSearch",
        "queryFilters",
        "isOpenFacets",
        "selected_category_name"
    ]),
    isLoading() {
      return this.$store.getters.loading;
    },
    curMode: function () {
      return this.mode
    }
  },
  watch: {
    queryFilters: {
      deep: true,
      handler: 'onFilterChanged'
    }
  },
  methods: {
    ...mapActions("search", ["doSearch", "setCurrentPage", "setDoSearchAddMore"]),
    loadMore: function($state) {

      let currentPage = this.currentPage+1;

      if(currentPage * this.pageSize > this.totalHits) {
        // сообщаем компоненте infinite-loading что все записи выведены
        $state.complete()
        return;
      }
      this.setCurrentPage(currentPage);
      this.setDoSearchAddMore(true);

      this.doSearch()
      .then(() => {
        $state.loaded()
      })
      .catch(err => {
        console.log(err.response.statusText)
      })
    },
    onFilterChanged: function () {
      if(this.$refs.InfiniteLoading){
        // сброс состояния компоненты infinite-loading
        this.$refs.InfiniteLoading.stateChanger.reset();
      }
    },
    /*checkScroll: function (e) {
      // in div v-scroll="checkScroll()"

      if ((this.isMobile && this.processScroll(e), this.pagination.isInfinite)) {
        if (((window.el = e), e.scrollTop + e.clientHeight >= e.scrollHeight - 2500)) {
          if (this.productList.isLoading) return;
          this.$store.dispatch("fetchProducts");
        }
        this.$store.commit("setButtonUpState", e.scrollTop > e.clientHeight);
      }
    }*/
  },
  /*directives: {
    scroll: {
        inserted: function (el, binding) {
          let f = function (evt) {
            if (binding.value(evt, el)) {
              window.removeEventListener('scroll', f)
            }
          }
          window.addEventListener('scroll', f)
        }
      }
  },*/
  components: {
    NotFound,
    ProductsGrid,
    FacetCategories,
    Facets,
    Sort,
    Tips,
    FacetSlider,
    BackToTop,
    InfiniteLoading
  }
}
</script>